import type { MembershipContractTimeline } from '@libs/data-access/entities'
import { isContractActive } from '@libs/data-access/queries'

export const getActiveContract = (contracts: MembershipContractTimeline[]) => {
  return contracts?.find(contract => isContractActive(contract))
}
